import { ResourceError } from './base/ResourceError';
import { DeploymentValidationProfile } from './deployment-validation-profile';
import { DeviceAuthentication } from './device-authentication';
export class Device {
  Id: string;
  Name: string;
  Description: string;
  LastCommitMessage: string;
  Errors: ResourceError[];
  ManufacturerId: string;
  DeviceTypeId: string;
  DataCenterSiteId: string;
  ProviderId: string;
  DeviceAuthenticationId: string;
  DeviceAuthentication: DeviceAuthentication;
  ConnectionProtocol?: DeviceConnectionProtocol;
  ConnectionPort?: number;
  EnableLegacySshAlgorithms?: boolean;
  SshConnectTimeoutSeconds?: number;
  SshCommandTimeoutSeconds?: number;
  SshKeyExchangeAlgorithms?: string[];
  SshHostKeyAlgorithms?: string[];
  SshPublicKeyAlgorithms?: string[];
  IpAddress: string;
  Fqdn: string;
  Tags: VpcTag[];
  CreatedDate?: Date;
  CreatedBy?: string;
  UpdatedDate?: Date;
  UpdatedBy?: string;
  Version: number;
  Image?: string;
  deviceImage?: string;
  RawConfig: string;
  RawConfigPath?: string;
  ParseConfig: string;
  CreateInstance: boolean;
  DeviceId?: string;
  InventoryId?: string;
  IntegrationId?: string;
  ConfigurationSource: ConfigurationSource;
  ComplianceParameters: ComplianceParameters[];
  ProviderName:string;
  SerialNumber:string;
  IsWorkflow: boolean;
  DeploymentValidationProfile:DeploymentValidationProfile; 
  BenchmarkIds:string[];
  DeviceConnectivityStatus: DeviceConnectivityStatus;
  ConfigurationState: ConfigurationState;
  AccountId?: string;
  ControllerUrl?: string;
  ControllerManaged?: boolean;
  ManageConfiguration?: boolean;
  ErrorMessage?: string;
  DetailedErrorMessage?: string;
}

export class VpcTag {
  Key: string;
  Value: string;
}

export class ComplianceParameters {
  Name: string;
  Type: ComplianceParameterType;
  Value: any;
}

export enum ComplianceParameterType {
  'Int' = 0,
  'DateTime' = 1,
  'Bool' = '2',
  'String' = 3,
  'ListOfString' = 4,
  'ListOfInt' = 5
}

export enum ConfigurationSource {
  'DirectSSH' = 0,
  'FileUpload' = 1,
  'PullFromIntegration' = 2,
  'Controller' = 3
}

export enum DeviceConnectionProtocol {
  Ssh = 0,
  Telnet = 1
}

export enum DeviceConnectivityStatus {
  Connecting = 0,
  Connected = 1,
  ConnectionFailed = 2 
}

export enum ConfigurationState {
  NotInitalized = 0,
  SyncInQueue = 1,
  SyncInProgress = 2,
  ParsingInQueue = 3,
  ParsingInProgress = 4,
  Healthy = 5,
  DriftDetected = 6,
  Failed = 7,
  ModelNotDefined = 8
}

export interface DeviceConnectivityResult {
  DeviceId: string;
  Status: DeviceConnectivityStatus;
  ErrorMessage?: string;
}

export interface DeviceSyncStatus {
  Id: string;
  DriftDeviceId?: string;
  RecordGroupId?: string;
  InventoryId?: string;
  ConfigurationState: ConfigurationState;
  DeviceConnectivityStatus: DeviceConnectivityStatus;
  ErrorMessage?: string;
  UpdatedDate?: Date;
}
